import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

// Centre nav items. Anchors point to homepage sections; when not on the
// homepage they navigate to /home#<id> (Home scrolls to the hash on load).
const NAV_LINKS = [
  { label: 'How it works', anchor: 'how' },
  { label: 'Find Crew', anchor: 'audience' },
  { label: 'Be Crew', anchor: 'audience', accent: true },
  { label: 'Meet the Crew', to: '/crew' },
  { label: 'Features', anchor: 'features' },
];

const PublicNav = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/' || location.pathname === '/home';
  const isCrew = location.pathname === '/crew';
  const anchorHref = (a) => (isHome ? `#${a}` : `/home#${a}`);

  const linkColor = (item) => {
    if (item.to === '/crew') return isCrew ? '#28C0D0' : 'rgba(255,255,255,.7)';
    return item.accent ? '#28C0D0' : 'rgba(255,255,255,.7)';
  };

  return (
    <nav
      className="fixed top-0 left-0 right-0 z-50 flex items-center justify-between"
      style={{
        padding: '16px 40px',
        background: 'rgba(12,17,32,.82)',
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
        borderBottom: '1px solid rgba(255,255,255,.08)',
      }}
    >
      <Link to="/" className="flex items-center shrink-0">
        <img src="/assets/website/horizontal-white.png" alt="Shootzu" style={{ height: 40, width: 'auto', display: 'block' }} />
      </Link>

      {/* Centre links — hidden ≤900px (lg) */}
      <div className="hidden lg:flex items-center" style={{ gap: 30, fontSize: 14.5, fontWeight: 500 }}>
        {NAV_LINKS.map((item) =>
          item.to ? (
            <Link key={item.label} to={item.to} style={{ color: linkColor(item), textDecoration: 'none', fontWeight: item.to === '/crew' && isCrew ? 600 : 500 }}>
              {item.label}
            </Link>
          ) : (
            <a key={item.label} href={anchorHref(item.anchor)} style={{ color: linkColor(item), textDecoration: 'none', fontWeight: item.accent ? 600 : 500 }}>
              {item.label}
            </a>
          )
        )}
      </div>

      {/* Right actions */}
      <div className="hidden lg:flex items-center" style={{ gap: 14 }}>
        <Link to="/login" style={{ fontSize: 14, fontWeight: 500, color: 'rgba(255,255,255,.78)', textDecoration: 'none' }}>
          Sign in
        </Link>
        <Link
          to="/signup"
          style={{ fontSize: 14, fontWeight: 600, color: '#0C1120', background: '#28C0D0', borderRadius: 999, padding: '11px 20px', textDecoration: 'none' }}
        >
          Join free
        </Link>
      </div>

      {/* Mobile toggle */}
      <button className="lg:hidden text-white p-2" onClick={() => setOpen(!open)} aria-label="Menu">
        {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
      </button>

      {/* Mobile menu */}
      {open && (
        <div
          className="lg:hidden fixed left-0 right-0"
          style={{ top: 73, background: '#0C1120', borderBottom: '1px solid rgba(255,255,255,.08)', padding: '14px 24px 22px' }}
        >
          <div className="flex flex-col" style={{ gap: 4 }}>
            {NAV_LINKS.map((item) =>
              item.to ? (
                <Link key={item.label} to={item.to} onClick={() => setOpen(false)} style={{ color: '#fff', textDecoration: 'none', padding: '12px 4px', fontSize: 16 }}>
                  {item.label}
                </Link>
              ) : (
                <a key={item.label} href={anchorHref(item.anchor)} onClick={() => setOpen(false)} style={{ color: '#fff', textDecoration: 'none', padding: '12px 4px', fontSize: 16 }}>
                  {item.label}
                </a>
              )
            )}
            <div className="flex items-center gap-3" style={{ marginTop: 12 }}>
              <Link to="/login" onClick={() => setOpen(false)} className="flex-1 text-center" style={{ color: '#fff', border: '1px solid rgba(255,255,255,.2)', borderRadius: 999, padding: '12px 0', textDecoration: 'none', fontWeight: 600 }}>
                Sign in
              </Link>
              <Link to="/signup" onClick={() => setOpen(false)} className="flex-1 text-center" style={{ color: '#0C1120', background: '#28C0D0', borderRadius: 999, padding: '12px 0', textDecoration: 'none', fontWeight: 700 }}>
                Join free
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default PublicNav;
